module.exports = __webpack_public_path__ + "img/image_0_2.851e7251.jpg";